import React from "react";
import MuiWarningIcon from "@mui/icons-material/Warning";

// Source
import * as ModelRoute from "../model/Route";
import ControllerAccessDenided from "../controller/AccessDenied";
import ControllerLocalization from "../controller/Localization";
import ViewLoader from "./Loader";

let isRendered = false;

const viewPageAccessDenied: React.FC<ModelRoute.Iprops> = (props) => {
    // Variable
    const controllerAccessDenided = new ControllerAccessDenided(props, isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerAccessDenided.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerAccessDenided.getRoleRequire && controllerLocalization.getStorageMain) {
        return (
            <div className="view_access_denied" data-at_id="view_access_denied">
                <div>
                    <MuiWarningIcon className="icon" />
                    <p>{controllerLocalization.getStorageMain.access_denied_message.replace("%a", controllerAccessDenided.getRoleRequire)}</p>
                </div>
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageAccessDenied;
